import React, { useState } from 'react';
import SelectSearchDropDown from 'Components/Form/SearchDropDown/SelectSearchDropDown';
import { CustomButton } from 'Components/Auth/CustomButton';
import { Service } from 'app/services/responseTypes';

interface Props {
  service: Service;
  businesses: { name: string; id: number | null }[];
  onSelect: (businessId: number | null) => void;
  onClose: () => void;
}

export default function BusinessSelectModal({
  service,
  businesses,
  onSelect,
  onClose,
}: Props) {
  const [selected, setSelected] = useState(
    businesses.find((b) => b.id === null) || businesses[0],
  );

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center modal-overlay"
      onClick={(e) =>
        (e.target as Element).classList.contains('modal-overlay') && onClose()
      }
    >
      <div className="bg-white p-6 rounded-lg w-96 relative max-h-[90vh] overflow-y-auto">
        <button
          className="absolute top-2 right-2 text-gray-500 hover:text-gray-800"
          onClick={onClose}
        >
          ✖
        </button>
        <h3 className="text-lg font-bold mb-4">{service.title}</h3>
        <p className="text-gray-600 mb-4">
          Price: ${service.prices[0]?.amount_cents / 100}
        </p>
        <div className="my-4">
          <SelectSearchDropDown
            options={businesses}
            value={selected}
            onChange={(e) => setSelected(e)}
            clearable={false}
            borderInputColor="border-green"
            dropDownArrowColor="text-green"
            searchFilter={(search, options) =>
              options.filter((x) =>
                x.name.toLowerCase().includes(search.toLowerCase()),
              )
            }
            selectedItemSkin={(category) => (
              <span className="font-semibold text-green">{category.name}</span>
            )}
            optionItemSkin={(category) => category.name}
          />
        </div>
        <div className="flex justify-end gap-4 mt-6">
          <CustomButton
            text="Cancel"
            bgColor="gray-300"
            textColor="gray-800"
            onClick={onClose}
          />
          <CustomButton
            text="Add to Cart"
            bgColor="green"
            textColor="white"
            onClick={() => onSelect(selected.id)}
          />
        </div>
      </div>
    </div>
  );
}
